import React, { useEffect, useState, useMemo } from 'react'
import WorkflowPhasesPage from '../../../Operations/Scenes/Workflows/Components/WorkflowPhasesPage';
import GetWorkflowMainCategoryService from '../../../../../../Service/OPSServices/WorkflowsService/GetWorkflowMainCategoryService';
import { connect } from 'react-redux';
import WorkflowIcon from '../../../../../../../src/designUtils/ProjectDashboard/WorkflowIcon.svg';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from "reactstrap";
import WorkflowUpdatedPhase from '../../../Operations/Scenes/Workflows_v1/Components/WorkflowUpdatedPhase';

export const ProactiveWorkflowsDropDownOption = (props) => {

  const [selectedItem, setSelectedItem] = useState(null)
  const [showWorkflows, setShowWorkflows] = useState(false);
  useEffect(() => {
    if (props.pageRedirect !== "Workflow") {
      setSelectedItem(null);
      setShowWorkflows(false); // optional: collapse the workflow list
    }
  }, [props.pageRedirect]);

  const selectedName = selectedItem !== null && props.buttons && props.buttons[selectedItem]
    ? props.buttons[selectedItem].name
    : "";

  return (
    <div className={`workflow-sidebar-section ${props.class || ''}`}>
      
    {/* <div className="d-flex align-items-center mb-2 project-dashboard-sidebar cursor-pointer"> */}
      
    
    <div className="workflow-menu">

{/* Header */}
<div
  className="workflow-header"
  onClick={() => setShowWorkflows(!showWorkflows)}
>
  <div className="d-flex align-items-center">
    <img
      src={WorkflowIcon}
      alt="Workflow"
      className="project-dashboard-sidebar-icon mr-2"
    />
    <span className="workflow-title">Workflows</span>
  </div>

 <span className='ml-2'> <i
    className={`fa ${
      showWorkflows ? "fa-chevron-up" : "fa-chevron-down"
    }`}
  /></span>
</div>

{/* List */}
{showWorkflows && (
  <div className="workflow-submenu">
    {(props.buttons || []).map((item, index) => (
      <div
        key={item.id}
        className={`workflow-submenu-item ${
          selectedItem === index ? "active" : ""
        }`}
        onClick={() => {
          setSelectedItem(index);
          props.handleWorkflowChange(item);
        }}
      >
        {item.name}
      </div>
    ))}
  </div>
)}
</div>
    </div>
    // </div>
  )
}

function ProjectsDashWorkFlowsMainPage(props) {
    const [workflowPhasesList,setWorkflowPhasesList]=useState()
    const [workflowMainCategory, setWorkflowMainCategory] = useState("");
    const [workflowMasterPhases, setWorkflowMasterPhases] = useState([]);

    // const [selectedStoreData, setSelectedStoreData] = useState({
    //     integerId: "",
    //     storeName: "",
    //   });
    const selectedStoreData = useMemo(() => {
      return {
        integerId: props.selectedProjectData &&props.selectedProjectData.integerId || '',
        storeName: props.selectedProjectData &&props.selectedProjectData.storeName || ''
      };
    }, [props.selectedProjectData]);

    useEffect(()=>{
        console.log(props.selectedProjectData);
        console.log(props.selectedWorkflowMasterId)
        // setSelectedStoreData({integerId:props.selectedProjectData.integerId,
        //     storeName:props.selectedProjectData.storeName
        //     }
        // )
        GetWorkflowMainCategoryService(props.token).then((res)=>{
            console.log(res);
            setWorkflowMainCategory(res.masterWorkflows);
            setWorkflowMasterPhases(res.masterPhase || []);
            // const filteredPhases = res.workflowPhases && res.workflowPhases.filter(phase => phase.WorkflowsMaster == props.selectedProjectData.workflowsId).sort((a, b) => a.id - b.id);
          
            let workflowIds = props.selectedProjectData &&props.selectedProjectData.workflowsId;

        // convert to array safely
        if (!Array.isArray(workflowIds)) {
          workflowIds = workflowIds ? [workflowIds] : [];
      }

      const filteredPhases =
      res.workflowPhases &&
      res.workflowPhases
          .filter(phase =>
              Number(phase.WorkflowsMaster) === Number(props.selectedWorkflowMasterId)
          )
          .sort((a, b) => a.id - b.id);

        setWorkflowPhasesList(filteredPhases);
        })
      },[props.selectedWorkflowMasterId, props.token, props.selectedProjectData])

  return (

  <>
  <div className="ml-3">
    {props.selectedWorkflowMasterId ==10?
    <WorkflowUpdatedPhase
    flag={false}
    selectedWorkflowMasterId={props.selectedWorkflowMasterId}
    workflowPhases={workflowPhasesList}
    selectedProjectData={props.selectedProjectData}
    workflowMainCategory={workflowMainCategory}
    workflowMasterPhases={workflowMasterPhases}
    selectedStoreData={selectedStoreData}
    key={props.selectedWorkflowMasterId}
    hideBackButton={true}
    />
    :
    <WorkflowPhasesPage 
    flag={false}
    selectedWorkflowMasterId={props.selectedWorkflowMasterId}
    workflowPhases={workflowPhasesList}
    selectedProjectData={props.selectedProjectData}
    workflowMasterPhases={workflowMasterPhases}
    workflowMainCategory={workflowMainCategory}
    selectedStoreData={selectedStoreData}
    key={props.selectedWorkflowMasterId}
    hideBackButton={true}
    />
  }
   
  </div>
  </>
  )
}
const mapStateToProps = state => {
    return {
      token: state.loggedUser.token,
      accessLevel: state.loggedUser.accessLevel,
      status: state.loggedUser.status,
    }
  }
  
  export default connect(mapStateToProps)(ProjectsDashWorkFlowsMainPage);
